/**
 * navigation.js
 * The Central Nervous System of SSULWHA UI.
 * Defines all static menus and default dynamic configurations.
 */

// 1. Bottom Tabs (Mobile Core Navigation - Immutable)
export const BOTTOM_TABS = [
    { id: 'home', label: '홈', icon: 'Home', path: '/' },
    { id: 'webtoon', label: '웹툰', icon: 'BookOpen', path: '/webtoon' },
    { id: 'novel', label: '웹소설', icon: 'FileText', path: '/novel' },
    { id: 'library', label: '보관함', icon: 'Library', path: '/library' }, // Favorites/Recent
];

// 2. Drawer/Sidebar Menu Structure (Unified)
export const SIDEBAR_STRUCTURE = [
    // Section 1: Main Navigation
    { id: 'home', label: '홈', icon: 'Home', path: '/' },
    { id: 'webtoon', label: '웹툰', icon: 'BookOpen', path: '/webtoon' },
    { id: 'novel', label: '웹소설', icon: 'FileText', path: '/novel' },
    { id: 'library', label: '보관함', icon: 'Library', path: '/library' },
    { id: 'charge', label: '스타 충전소', icon: 'Star', path: '/charging-station' }, // Icon: Star

    { type: 'DIVIDER' },

    // Section 2: Management & Admin (Role Guarded)
    { id: 'admin', label: '관리자 페이지', icon: 'ShieldAlert', path: '/admin/content', role: 'admin', highlight: true }, // Icon: ShieldAlert
    { id: 'studio', label: '창작 스튜디오', icon: 'Palette', path: '/studio', role: 'author', highlight: true }, // Icon: Palette
    { id: 'config', label: '외부링크 삽입', icon: 'Link', path: '/admin/config', role: 'admin' }, // Icon: Link
    { id: 'factory', label: '팝업 & 공지 (Admin)', icon: 'Factory', path: '/admin/popups', role: 'admin' }, // Icon: Factory
    { id: 'docs', label: '문서 에디터 (Admin)', icon: 'FileText', path: '/admin/docs', role: 'admin' }, // Icon: FileText

    { id: 'analytics', label: '트렌드 분석 (Admin)', icon: 'TrendingUp', path: '/admin/analytics', role: 'admin' }, // Icon: TrendingUp

    { type: 'DIVIDER' },

    // Section 3: Community
    { id: 'plaza', label: '썰화클럽 (CLUB)', icon: 'Sparkles', path: '/plaza', highlight: true }, // Icon: Sparkles

    { type: 'DIVIDER' },

    // Section 4: Wisdom & Guide
    { id: 'wisdom', label: '성좌의 지혜', icon: 'Lightbulb', type: 'MODAL', component: 'ProposalModal' }, // Icon: Lightbulb
    { id: 'recommendation', label: '서재의 빈칸', icon: 'AutoAwesome', path: '/library/recommendation', highlight: true }, // [NEW] Taste Sniper
    { id: 'guide', label: '설화 가이드', icon: 'Compass', type: 'MODAL', component: 'GuideModal' }, // Icon: Compass
    { id: 'whats-new', label: "What's New", icon: 'Megaphone', type: 'MODAL', component: 'InfoModal', docId: 'whats-new' }, // Icon: Megaphone
    { id: 'invite', label: '친구 초대', icon: 'Share2', type: 'FUNCTION', action: 'shareLink' }, // Icon: Share2

    { type: 'DIVIDER' },

    // Section 5: Service Info
    { id: 'about', label: '서비스 소개', icon: 'Info', type: 'MODAL', component: 'InfoModal', docId: 'about' }, // Icon: Info
    { id: 'terms', label: '이용약관', icon: 'FileText', type: 'MODAL', component: 'InfoModal', docId: 'terms' }, // Reuse FileText
    { id: 'privacy', label: '개인정보처리방침', icon: 'Shield', type: 'MODAL', component: 'InfoModal', docId: 'privacy' }, // Icon: Shield
    { id: 'report', label: '신고 센터', icon: 'Siren', type: 'MODAL', component: 'ReportModal' }, // Icon: Siren
    { id: 'app-setting', label: '앱 설정', icon: 'Settings', path: '/settings' }, // Icon: Settings

    { type: 'DIVIDER' },

    // Section 6: Dynamic External Links (Marker)
    { type: 'EXTERNAL_LINKS_MARKER' },

    { type: 'DIVIDER' },

    // Section 7: Logout
    { id: 'logout', label: '로그아웃', icon: 'LogOut', type: 'FUNCTION', action: 'logout' } // Icon: LogOut
];


// Legacy export for compatibility if needed (but we should switch drawer to use SIDEBAR_STRUCTURE)
export const DRAWER_MENU = SIDEBAR_STRUCTURE.filter(item => item.type !== 'DIVIDER' && item.type !== 'EXTERNAL_LINKS_MARKER');

// 3. Header Actions (Top Right)
export const HEADER_ACTIONS = [
    { id: 'search', icon: 'Search', action: 'toggleSearch' },
    { id: 'notification', icon: 'Bell', action: 'toggleNotification' },
];

/**
 * Helper to get Link Object by ID
 * @param {string} id 
 */
export const getLinkById = (id) => {
    // Flatten SIDEBAR_STRUCTURE
    const sidebarItems = SIDEBAR_STRUCTURE.filter(i => i.id);
    const all = [...BOTTOM_TABS, ...sidebarItems, ...HEADER_ACTIONS];
    return all.find(item => item.id === id);
};
